export default __webpack_public_path__ + "static/media/AnimalGame_01.0351fec3.png";